// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditWishListGroup-editBtnMargin-yx5HG {
    margin: 0px 12px;
}

.EditWishListGroup-closeWidth-YzzUl {
    width: 100%;
    max-width: 12px;
}

.EditWishListGroup-noWishList-JReNo {
    text-align: center;
}

.EditWishListGroup-iconWidth-qcocw {
    max-width: 14px;
}

.EditWishListGroup-iconDeleteWidth-CdMyp {
    max-width: 12px;
}

.EditWishListGroup-listGrid-t_y0k {
    display: grid;
    grid-template-columns: 330px 330px 330px;
    gap: 30px;
}

@media (min-width: 768px) and (max-width: 1024px) {
    .EditWishListGroup-listGrid-t_y0k {
        grid-template-columns: repeat(auto-fill, 226px);
    }
}

@media screen and (max-width: 767px) {
    .EditWishListGroup-flexWrapMb-KSIOg {
        -ms-flex-wrap: wrap;
            flex-wrap: wrap;
        -webkit-box-pack: end;
            -ms-flex-pack: end;
                justify-content: end;
        gap: 12px;
    }

    .EditWishListGroup-listGrid-t_y0k {
        grid-template-columns: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/WishLists/EditWishListGroup/EditWishListGroup.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,wCAAwC;IACxC,SAAS;AACb;;AAEA;IACI;QACI,+CAA+C;IACnD;AACJ;;AAEA;IACI;QACI,mBAAe;YAAf,eAAe;QACf,qBAAoB;YAApB,kBAAoB;gBAApB,oBAAoB;QACpB,SAAS;IACb;;IAEA;QACI,2BAA2B;IAC/B;AACJ","sourcesContent":[".editBtnMargin {\n    margin: 0px 12px;\n}\n\n.closeWidth {\n    width: 100%;\n    max-width: 12px;\n}\n\n.noWishList {\n    text-align: center;\n}\n\n.iconWidth {\n    max-width: 14px;\n}\n\n.iconDeleteWidth {\n    max-width: 12px;\n}\n\n.listGrid {\n    display: grid;\n    grid-template-columns: 330px 330px 330px;\n    gap: 30px;\n}\n\n@media (min-width: 768px) and (max-width: 1024px) {\n    .listGrid {\n        grid-template-columns: repeat(auto-fill, 226px);\n    }\n}\n\n@media screen and (max-width: 767px) {\n    .flexWrapMb {\n        flex-wrap: wrap;\n        justify-content: end;\n        gap: 12px;\n    }\n\n    .listGrid {\n        grid-template-columns: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editBtnMargin": `EditWishListGroup-editBtnMargin-yx5HG`,
	"closeWidth": `EditWishListGroup-closeWidth-YzzUl`,
	"noWishList": `EditWishListGroup-noWishList-JReNo`,
	"iconWidth": `EditWishListGroup-iconWidth-qcocw`,
	"iconDeleteWidth": `EditWishListGroup-iconDeleteWidth-CdMyp`,
	"listGrid": `EditWishListGroup-listGrid-t_y0k`,
	"flexWrapMb": `EditWishListGroup-flexWrapMb-KSIOg`
};
module.exports = ___CSS_LOADER_EXPORT___;
